import about from "../img/about.svg"
import codeofconduct from "../img/codeofconduct.svg"
import comments from "../img/comments.svg"
import connect from "../img/connect.svg"
import contact from "../img/contact.svg"
import customizetags from "../img/customizetags.svg"
import dev from "../img/dev.svg"
import devshop from "../img/devshop.svg"
import dots from "../img/dots.svg"
import facebook from "../img/facebook.svg"
import faq from "../img/faq.svg"
import foremlogo from "../img/foremlogo.svg"
import github from "../img/github.svg"
import heart from "../img/heart.svg"
import home from "../img/home.svg"
import instagram from "../img/instagram.svg"
import likes from "../img/likes.svg"
import listings from "../img/listings.svg"
import notification from "../img/notification.svg"
import podcasts from "../img/podcasts.svg"
import privacypolicy from "../img/privacypolicy.svg"
import readinglist from "../img/readinglist.svg"
import save from "../img/save.svg"
import search from "../img/search.svg"
import sponsors from "../img/sponsors.svg"
import tags from "../img/tags.svg"
import termsofuse from "../img/termsofuse.svg"
import twitch from "../img/twitch.svg"
import twitter from "../img/twitter.svg"
import unicorn from "../img/unicorn.svg"
import videos from "../img/videos.svg"

export default {
    about,
    codeofconduct,
    comments,
    connect,
    contact,
    customizetags,
    dev,
    devshop,
    dots,
    facebook,
    faq,
    foremlogo,
    github,
    heart,
    home,
    instagram,
    likes,
    listings,
    notification,
    podcasts,
    privacypolicy,
    readinglist,
    save,
    search,
    sponsors,
    tags,
    termsofuse,
    twitch,
    twitter,
    unicorn,
    videos
}